<template>
  <div>
    <h5 class="mb-3">
      {{ dataComponent.name }}
    </h5>

    <div class="tabs mt-4">
      <div
        v-for="(tab, index) in tabs"
        :key="tab"
        :class="{'tab-active': index === 0}"
        class="tab-list"
      >
        {{ tab }}
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <i class="fa fa-cogs icon-setting" />
    </div>

    <!-- Button -->
    <div class="d-flex align-items-center mt-3">
      <b-button class="btn blue m__r--5">Create Task Project</b-button>
      <b-button class="btn outline grey m__r--5">
        <i class="fa fa-download" />
      </b-button>
      <b-button
        class="btn outline grey m__r--5"
        style="border-color: #dfdfea;"
      >
        Import File
      </b-button>
      <b-button class="btn green">Export XLS</b-button>
    </div>

    <p class="advanced-search">Advanced Search <i class="fa fa-angle-right" /></p>

    <!-- Columns -->
    <div class="columns mt-3">
      <div class="d-flex align-items-center">
        <div
          v-for="column in columns"
          :key="column"
          class="column"
        >
          <div
            class="header-list"
            style="cursor: default !important;"
          >
            <div class="column-name">{{ column }}</div>
          </div>
          <div
            v-for="index in 4"
            :key="index"
            :class="{'bg-gray': index === 2 || index === 4}"
            class="column-preview"
            style="cursor: default !important;"
          >
            <div class="content-preview"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataComponent: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      tabs: [
        'Task Project',
        'Task Assignment',
      ],
      columns: [
        'PROJECT',
        'TASK CODE',
        'TASK',
        'DURATION',
        'FORM',
        'CREATED DATE',
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  display: flex;
  align-items: center;
  overflow-x: scroll;

  .tab-list {
    font-family: 'Poppins-Medium';
    font-size: 14px;
    color: $gray-1;
    white-space: nowrap;
    padding-bottom: 7px;
    margin-right: 20px;
    border-bottom: 4px solid transparent;

    &.tab-active {
      border-color: $primary;
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
}

.icon-setting {
  font-size: 24px;
  color: #42a5ce;
}
.advanced-search {
  font-family: 'Poppins-Semibold';
  font-size: 14px;
  color: #42a5ce;
  margin-top: 10px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyTimesheetConfig.vue